import React from "react";
import {
  ButtonFilterSearch,
  DatetimePicker,
  TextInput,
} from "../../components";
import { FormGroup, FormGroupVerticalInput, Label } from "../../components";
import { hasErrorInput } from "../../utils";

const LogPanelFilter = ({
  formData,
  setFormData,
  handleSubmitSearch,
  errors,
  buttonId = "",
}) => {
  const handleChangeFormData = (fieldName, value) => {
    setFormData((preFormData) => ({
      ...preFormData,
      [fieldName]: value,
    }));
  };
  return (
    <div className="border border-tenken-gray-300 rounded-lg flex bg-white xl:px-5 xl:pt-4 xl:pb-3 px-4 pt-3 pb-2 w-full mt-[4px] 2xl:space-x-10 xl:space-x-5 space-x-4">
      <FormGroup
        direction="vertical"
        className="2xl:max-w-[240px] xl:max-w-[220px] lg:max-w-[180px] md:max-w-[140px]"
      >
        <Label text="ユーザーID" htmlFor="username" className="mb-[3px]" />
        <FormGroupVerticalInput>
          <TextInput
            name="username"
            id="username"
            hasError={hasErrorInput(errors, "username")}
            onChange={(e) => handleChangeFormData("username", e.target.value)}
            value={formData.username || ""}
            autoFocus
            maxLength="20"
          />
        </FormGroupVerticalInput>
      </FormGroup>
      <FormGroup
        direction="vertical"
        className="2xl:max-w-[320px] xl:max-w-[240px] lg:max-w-[200px] md:max-w-[140px]"
      >
        <Label text="ユーザー名" htmlFor="name" className="mb-[3px]" />
        <FormGroupVerticalInput>
          <TextInput
            name="name"
            id="name"
            hasError={hasErrorInput(errors, "name")}
            onChange={(e) => handleChangeFormData("name", e.target.value)}
            value={formData.name || ""}
            maxLength="40"
          />
        </FormGroupVerticalInput>
      </FormGroup>
      <FormGroup direction="vertical" groupWidth="w-fit">
        <Label text="更新日" htmlFor="start_date" className="mb-[3px]" />
        <FormGroupVerticalInput>
          <div className="flex flex-row space-x-2">
            <DatetimePicker
              id="start_date"
              name="start_date"
              timeFormat={false}
              nextFocus="end_date"
              hasError={hasErrorInput(errors, "start_date")}
              className="lg:w-[160px] w-[120px]"
              onChange={handleChangeFormData}
              value={formData.start_date || ""}
              maxLength="15"
            />
            <span className="2xl:text-[26px] xl:text-[22px] md:text-[22px]">
              ~
            </span>
            <DatetimePicker
              id="end_date"
              name="end_date"
              timeFormat={false}
              hasError={hasErrorInput(errors, "end_date")}
              className="lg:w-[160px] w-[120px]"
              onChange={handleChangeFormData}
              value={formData.end_date || ""}
              maxLength="15"
            />
          </div>
        </FormGroupVerticalInput>
      </FormGroup>
      <FormGroup direction="vertical" className="mt-[30px] lg:mt-8">
        <ButtonFilterSearch onClick={handleSubmitSearch} id={buttonId} />
      </FormGroup>
    </div>
  );
};

export default LogPanelFilter;
